import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Addon = {
  __typename?: 'Addon';
  addonId: Scalars['String'];
  addonName: Scalars['String'];
  addonPriceId: Scalars['String'];
  addonPriceName: Scalars['String'];
  description: Scalars['String'];
  entitlementDetails?: Maybe<Array<Entitlement>>;
  isPurchased: Scalars['Boolean'];
  periodUnit: Scalars['String'];
  pricingModel: Scalars['String'];
  quantity: Scalars['Int'];
  tiers?: Maybe<Array<Tier>>;
  unitPrice: Scalars['Float'];
};

export type AddonDetail = {
  addonId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type AddonDetails = {
  __typename?: 'AddonDetails';
  id: Scalars['String'];
  name: Scalars['String'];
  purchased: Scalars['Boolean'];
};

export type AppPricingConfigInput = {
  Prices: Array<Price>;
  defaultPricing: Price;
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
};

export type AppPricingConfigResponse = {
  __typename?: 'AppPricingConfigResponse';
  Prices?: Maybe<Array<Maybe<AppPricingOutput>>>;
  defaultPricing?: Maybe<AppPricingOutput>;
  environmentName: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  workflowId: Scalars['String'];
};

export type AppPricingOutput = {
  __typename?: 'AppPricingOutput';
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
};

export type CbPricingPageSessionInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CbPricingPageSessionResponse = {
  __typename?: 'CBPricingPageSessionResponse';
  created_at: Scalars['Int'];
  expires_at: Scalars['Int'];
  id: Scalars['String'];
  object: Scalars['String'];
  url: Scalars['String'];
};

export type CbSessionInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CbSessionLogoutInput = {
  BillingCustId?: InputMaybe<Scalars['ID']>;
  PortalSessionId: Scalars['ID'];
  SBId: Scalars['ID'];
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CheckoutUrlResponse = {
  __typename?: 'CheckoutUrlResponse';
  url: Scalars['String'];
};

export type Coupon = {
  __typename?: 'Coupon';
  DiscountPercentage: Scalars['Int'];
  DiscountType: Scalars['String'];
  Name: Scalars['String'];
  Period: Scalars['Int'];
  PeriodUnit: Scalars['String'];
  Status: Scalars['String'];
  ValidTill: Scalars['Int'];
};

export type CreateBillingDetailsInput = {
  accountId: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateBillingDetailsResponse = {
  __typename?: 'CreateBillingDetailsResponse';
  accountId: Scalars['String'];
  billingCustId: Scalars['String'];
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type Entitlement = {
  __typename?: 'Entitlement';
  feature_id: Scalars['String'];
  feature_name: Scalars['String'];
  feature_type: Scalars['String'];
  is_enabled: Scalars['Boolean'];
  is_overridden: Scalars['Boolean'];
  name: Scalars['String'];
  object: Scalars['String'];
  subscription_id: Scalars['ID'];
  value: Scalars['String'];
};

export type EntitlementDetails = {
  __typename?: 'EntitlementDetails';
  feature_id: Scalars['String'];
  feature_name: Scalars['String'];
  feature_type: Scalars['String'];
  is_enabled: Scalars['Boolean'];
  is_overridden: Scalars['Boolean'];
  name: Scalars['String'];
  object: Scalars['String'];
  subscription_id: Scalars['String'];
  value: Scalars['String'];
};

export type EntitlementInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type GetAccountPriceMappingInput = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  pricingId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetAccountPriceMappingResponse = {
  __typename?: 'GetAccountPriceMappingResponse';
  emailId: Scalars['String'];
  price: AppPricingOutput;
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetAccountPricingDetailsInput = {
  accountId: Scalars['String'];
};

export type GetAccountPricingDetailsResponse = {
  __typename?: 'GetAccountPricingDetailsResponse';
  accountId: Scalars['String'];
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
};

export type GetAppPricingConfigRequest = {
  configurationName: Scalars['String'];
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
};

export type GetAppPricingConfigRequestv2 = {
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type GetAppPricingConfigResponse = {
  __typename?: 'GetAppPricingConfigResponse';
  Prices?: Maybe<Array<Maybe<AppPricingOutput>>>;
  defaultPricing?: Maybe<AppPricingOutput>;
  workflowId: Scalars['String'];
};

export type GetCheckoutUrlForExistingSubscriptionInput = {
  cancelUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type GetPlanDetailsForProductResponse = {
  __typename?: 'GetPlanDetailsForProductResponse';
  addonDetails?: Maybe<Array<AddonDetails>>;
  consumedAPIPercent: Scalars['Float'];
  consumedMausPercent: Scalars['Float'];
  description: Scalars['String'];
  inTrial: Scalars['Boolean'];
  planId: Scalars['String'];
  planName: Scalars['String'];
  purchasedAPICalls: Scalars['String'];
  purchasedMaus: Scalars['Int'];
  quantity: Scalars['Int'];
  trialExpiryInDays: Scalars['Int'];
  unitPrice: Scalars['Float'];
  usedAPICalls: Scalars['String'];
  usedMaus: Scalars['Int'];
};

export type GetPricingDetailsForProductInput = {
  billingCycle?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  thriveStackProductName: ThriveStackProductName;
};

export type GetPricingDetailsForProductResponse = {
  __typename?: 'GetPricingDetailsForProductResponse';
  billingCycle: Scalars['String'];
  currencyCode: Scalars['String'];
  plans?: Maybe<Array<PlanDetails>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBillingDetails: CreateBillingDetailsResponse;
  getAccountPriceMapping: GetAccountPriceMappingResponse;
  storeAppPricingConfig: AppPricingConfigResponse;
  updatePlanForSubscription: UpdatePlanForSubscriptionResponse;
};


export type MutationCreateBillingDetailsArgs = {
  input: CreateBillingDetailsInput;
};


export type MutationGetAccountPriceMappingArgs = {
  input: GetAccountPriceMappingInput;
};


export type MutationStoreAppPricingConfigArgs = {
  input: AppPricingConfigInput;
};


export type MutationUpdatePlanForSubscriptionArgs = {
  input: UpdatePlanForSubscriptionInput;
};

export type PlanDetails = {
  __typename?: 'PlanDetails';
  appliedAddons?: Maybe<Array<Addon>>;
  availableAddons?: Maybe<Array<Addon>>;
  billingPeriod: Scalars['String'];
  description: Scalars['String'];
  entitledEvents: Scalars['String'];
  entitledMaus: Scalars['Int'];
  entitlementDetails?: Maybe<Array<EntitlementDetails>>;
  isApplied: Scalars['Boolean'];
  planId: Scalars['String'];
  planName: Scalars['String'];
  planPriceId: Scalars['String'];
  planPriceName: Scalars['String'];
  pricingModel: Scalars['String'];
  quantity: Scalars['Int'];
  tiers?: Maybe<Array<Tier>>;
  trialEnds: Scalars['Int'];
  trialPeriod: Scalars['Int'];
  trialPeriodUnit: Scalars['String'];
  unitPrice: Scalars['Int'];
};

export type PortalSessionResponse = {
  __typename?: 'PortalSessionResponse';
  access_url: Scalars['String'];
  created_at: Scalars['Int'];
  customer_id: Scalars['String'];
  expires_at: Scalars['Int'];
  id: Scalars['ID'];
  object: Scalars['String'];
  status: Scalars['String'];
  token: Scalars['String'];
};

export type Price = {
  PriceId: Scalars['String'];
  PriceName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  getAccountPricingDetails: GetAccountPricingDetailsResponse;
  getAppPricingConfigv2: GetAppPricingConfigResponse;
  getCheckoutUrlForExistingSubscription: CheckoutUrlResponse;
  getEntitlements: SubscriptionEntitlementResponse;
  getPlanDetailsForProduct: GetPlanDetailsForProductResponse;
  getPortalSession: PortalSessionResponse;
  getPricingDetailsForProduct: GetPricingDetailsForProductResponse;
  getPricingPageSession: CbPricingPageSessionResponse;
  getSubscription: SubscriptionResponse;
  logOutPortalSession: PortalSessionResponse;
  retrieveSubscriptionPricing: SubscriptionPricingResponse;
};


export type QueryGetAccountPricingDetailsArgs = {
  input: GetAccountPricingDetailsInput;
};


export type QueryGetAppPricingConfigv2Args = {
  input: GetAppPricingConfigRequestv2;
};


export type QueryGetCheckoutUrlForExistingSubscriptionArgs = {
  input: GetCheckoutUrlForExistingSubscriptionInput;
};


export type QueryGetEntitlementsArgs = {
  input: EntitlementInput;
};


export type QueryGetPlanDetailsForProductArgs = {
  input: GetPricingDetailsForProductInput;
};


export type QueryGetPortalSessionArgs = {
  input?: InputMaybe<CbSessionInput>;
};


export type QueryGetPricingDetailsForProductArgs = {
  input: GetPricingDetailsForProductInput;
};


export type QueryGetPricingPageSessionArgs = {
  input: CbPricingPageSessionInput;
};


export type QueryGetSubscriptionArgs = {
  input: SubscriptionInput;
};


export type QueryLogOutPortalSessionArgs = {
  input?: InputMaybe<CbSessionLogoutInput>;
};


export type QueryRetrieveSubscriptionPricingArgs = {
  input: RetrieveSubscriptionPricing;
};

export type RetrieveSubscriptionPricing = {
  productId: Scalars['String'];
};

export type SubscriptionEntitlementResponse = {
  __typename?: 'SubscriptionEntitlementResponse';
  entitlements?: Maybe<Array<Entitlement>>;
};

export type SubscriptionInput = {
  billingCustId?: InputMaybe<Scalars['ID']>;
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
  sbId: Scalars['ID'];
};

export type SubscriptionPricingResponse = {
  __typename?: 'SubscriptionPricingResponse';
  addonDetails?: Maybe<Array<Addon>>;
  amount: Scalars['Float'];
  billingCycles: Scalars['Int'];
  billingPeriod: Scalars['Int'];
  billingPeriodUnit: Scalars['String'];
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  currencyCode: Scalars['String'];
  currentTermEnd: Scalars['Int'];
  currentTermStart: Scalars['Int'];
  description: Scalars['String'];
  inTrial: Scalars['Boolean'];
  nextBillingAt: Scalars['Int'];
  planId: Scalars['String'];
  planName: Scalars['String'];
  purchasedMtus: Scalars['Int'];
  quantity: Scalars['Int'];
  startDate: Scalars['Int'];
  subscriptionId: Scalars['String'];
  trialEnd: Scalars['Int'];
  trialStart: Scalars['Int'];
  unitPrice: Scalars['Float'];
  usedMtus: Scalars['Int'];
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  billing_period?: Maybe<Scalars['Int']>;
  billing_period_unit?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Int']>;
  created_from_ip?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['ID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  has_scheduled_changes?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  item_price_id?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  next_billing_at?: Maybe<Scalars['Int']>;
  resource_version?: Maybe<Scalars['Float']>;
  started_at?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trial_end?: Maybe<Scalars['Int']>;
  trial_start?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Int']>;
};

export enum ThriveStackProductName {
  CustomerAnalytics = 'CustomerAnalytics'
}

export type Tier = {
  __typename?: 'Tier';
  endingUnit: Scalars['Int'];
  price: Scalars['Int'];
  startingUnit: Scalars['Int'];
};

export type UpdatePlanForSubscriptionInput = {
  addonDetails: Array<AddonDetail>;
  planId: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
  sourceUrl: Scalars['String'];
};

export type UpdatePlanForSubscriptionResponse = {
  __typename?: 'UpdatePlanForSubscriptionResponse';
  isSuccess: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
};

export type UserPriceMappingInput = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type UserPriceMappingInputv2 = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  pricingId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type UserPriceMappingResponse = {
  __typename?: 'UserPriceMappingResponse';
  emailId: Scalars['String'];
  price: AppPricingOutput;
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetEntitlementsQueryVariables = Exact<{
  input: EntitlementInput;
}>;


export type GetEntitlementsQuery = { __typename?: 'Query', getEntitlements: { __typename?: 'SubscriptionEntitlementResponse', entitlements?: Array<{ __typename?: 'Entitlement', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null } };

export type GetPortalSessionQueryVariables = Exact<{
  input?: InputMaybe<CbSessionInput>;
}>;


export type GetPortalSessionQuery = { __typename?: 'Query', getPortalSession: { __typename?: 'PortalSessionResponse', id: string, token: string, access_url: string, status: string, created_at: number, expires_at: number, object: string, customer_id: string } };

export type GetPricingPageSessionQueryVariables = Exact<{
  input: CbPricingPageSessionInput;
}>;


export type GetPricingPageSessionQuery = { __typename?: 'Query', getPricingPageSession: { __typename?: 'CBPricingPageSessionResponse', id: string, url: string, created_at: number, expires_at: number, object: string } };

export type RetrieveSubscriptionPricingQueryVariables = Exact<{
  input: RetrieveSubscriptionPricing;
}>;


export type RetrieveSubscriptionPricingQuery = { __typename?: 'Query', retrieveSubscriptionPricing: { __typename?: 'SubscriptionPricingResponse', subscriptionId: string, amount: number, unitPrice: number, quantity: number, planId: string, planName: string, currencyCode: string, billingCycles: number, trialEnd: number, trialStart: number, billingPeriod: number, billingPeriodUnit: string, currentTermStart: number, currentTermEnd: number, nextBillingAt: number, startDate: number, purchasedMtus: number, inTrial: boolean, description: string, coupons?: Array<{ __typename?: 'Coupon', Name: string, ValidTill: number, Status: string, DiscountPercentage: number, DiscountType: string, Period: number, PeriodUnit: string } | null> | null, addonDetails?: Array<{ __typename?: 'Addon', addonId: string, addonName: string, addonPriceId: string, addonPriceName: string, pricingModel: string, unitPrice: number, quantity: number, description: string, periodUnit: string, isPurchased: boolean, tiers?: Array<{ __typename?: 'Tier', startingUnit: number, endingUnit: number, price: number }> | null, entitlementDetails?: Array<{ __typename?: 'Entitlement', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null }> | null } };

export type GetPricingDetailsForProductQueryVariables = Exact<{
  input: GetPricingDetailsForProductInput;
}>;


export type GetPricingDetailsForProductQuery = { __typename?: 'Query', getPricingDetailsForProduct: { __typename?: 'GetPricingDetailsForProductResponse', currencyCode: string, billingCycle: string, plans?: Array<{ __typename?: 'PlanDetails', planId: string, planName: string, planPriceId: string, planPriceName: string, pricingModel: string, unitPrice: number, quantity: number, trialEnds: number, isApplied: boolean, description: string, billingPeriod: string, trialPeriod: number, trialPeriodUnit: string, entitledMaus: number, entitledEvents: string, tiers?: Array<{ __typename?: 'Tier', startingUnit: number, endingUnit: number, price: number }> | null, entitlementDetails?: Array<{ __typename?: 'EntitlementDetails', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null, appliedAddons?: Array<{ __typename?: 'Addon', addonId: string, addonName: string, addonPriceId: string, addonPriceName: string, pricingModel: string, unitPrice: number, quantity: number, description: string, periodUnit: string, isPurchased: boolean, tiers?: Array<{ __typename?: 'Tier', startingUnit: number, endingUnit: number, price: number }> | null, entitlementDetails?: Array<{ __typename?: 'Entitlement', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null }> | null, availableAddons?: Array<{ __typename?: 'Addon', addonId: string, addonName: string, addonPriceId: string, addonPriceName: string, pricingModel: string, unitPrice: number, quantity: number, description: string, periodUnit: string, isPurchased: boolean, tiers?: Array<{ __typename?: 'Tier', startingUnit: number, endingUnit: number, price: number }> | null, entitlementDetails?: Array<{ __typename?: 'Entitlement', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null }> | null }> | null } };

export type GetCheckoutUrlForExistingSubscriptionQueryVariables = Exact<{
  input: GetCheckoutUrlForExistingSubscriptionInput;
}>;


export type GetCheckoutUrlForExistingSubscriptionQuery = { __typename?: 'Query', getCheckoutUrlForExistingSubscription: { __typename?: 'CheckoutUrlResponse', url: string } };

export type GetPlanDetailsForProductQueryVariables = Exact<{
  input: GetPricingDetailsForProductInput;
}>;


export type GetPlanDetailsForProductQuery = { __typename?: 'Query', getPlanDetailsForProduct: { __typename?: 'GetPlanDetailsForProductResponse', planId: string, planName: string, description: string, unitPrice: number, quantity: number, purchasedMaus: number, usedMaus: number, purchasedAPICalls: string, usedAPICalls: string, consumedAPIPercent: number, consumedMausPercent: number, trialExpiryInDays: number, inTrial: boolean, addonDetails?: Array<{ __typename?: 'AddonDetails', name: string, id: string, purchased: boolean }> | null } };

export type UpdatePlanForSubscriptionMutationVariables = Exact<{
  input: UpdatePlanForSubscriptionInput;
}>;


export type UpdatePlanForSubscriptionMutation = { __typename?: 'Mutation', updatePlanForSubscription: { __typename?: 'UpdatePlanForSubscriptionResponse', isSuccess: boolean, redirectUrl?: string | null } };


export const GetEntitlementsDocument = gql`
    query GetEntitlements($input: EntitlementInput!) {
  getEntitlements(input: $input) {
    entitlements {
      subscription_id
      feature_id
      feature_name
      feature_type
      value
      name
      is_overridden
      is_enabled
      object
    }
  }
}
    `;

/**
 * __useGetEntitlementsQuery__
 *
 * To run a query within a React component, call `useGetEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitlementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEntitlementsQuery(baseOptions: Apollo.QueryHookOptions<GetEntitlementsQuery, GetEntitlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntitlementsQuery, GetEntitlementsQueryVariables>(GetEntitlementsDocument, options);
      }
export function useGetEntitlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntitlementsQuery, GetEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntitlementsQuery, GetEntitlementsQueryVariables>(GetEntitlementsDocument, options);
        }
export type GetEntitlementsQueryHookResult = ReturnType<typeof useGetEntitlementsQuery>;
export type GetEntitlementsLazyQueryHookResult = ReturnType<typeof useGetEntitlementsLazyQuery>;
export type GetEntitlementsQueryResult = Apollo.QueryResult<GetEntitlementsQuery, GetEntitlementsQueryVariables>;
export const GetPortalSessionDocument = gql`
    query GetPortalSession($input: CBSessionInput) {
  getPortalSession(input: $input) {
    id
    token
    access_url
    status
    created_at
    expires_at
    object
    customer_id
  }
}
    `;

/**
 * __useGetPortalSessionQuery__
 *
 * To run a query within a React component, call `useGetPortalSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalSessionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPortalSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetPortalSessionQuery, GetPortalSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalSessionQuery, GetPortalSessionQueryVariables>(GetPortalSessionDocument, options);
      }
export function useGetPortalSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalSessionQuery, GetPortalSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalSessionQuery, GetPortalSessionQueryVariables>(GetPortalSessionDocument, options);
        }
export type GetPortalSessionQueryHookResult = ReturnType<typeof useGetPortalSessionQuery>;
export type GetPortalSessionLazyQueryHookResult = ReturnType<typeof useGetPortalSessionLazyQuery>;
export type GetPortalSessionQueryResult = Apollo.QueryResult<GetPortalSessionQuery, GetPortalSessionQueryVariables>;
export const GetPricingPageSessionDocument = gql`
    query GetPricingPageSession($input: CBPricingPageSessionInput!) {
  getPricingPageSession(input: $input) {
    id
    url
    created_at
    expires_at
    object
  }
}
    `;

/**
 * __useGetPricingPageSessionQuery__
 *
 * To run a query within a React component, call `useGetPricingPageSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPageSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPageSessionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPricingPageSessionQuery(baseOptions: Apollo.QueryHookOptions<GetPricingPageSessionQuery, GetPricingPageSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingPageSessionQuery, GetPricingPageSessionQueryVariables>(GetPricingPageSessionDocument, options);
      }
export function useGetPricingPageSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingPageSessionQuery, GetPricingPageSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingPageSessionQuery, GetPricingPageSessionQueryVariables>(GetPricingPageSessionDocument, options);
        }
export type GetPricingPageSessionQueryHookResult = ReturnType<typeof useGetPricingPageSessionQuery>;
export type GetPricingPageSessionLazyQueryHookResult = ReturnType<typeof useGetPricingPageSessionLazyQuery>;
export type GetPricingPageSessionQueryResult = Apollo.QueryResult<GetPricingPageSessionQuery, GetPricingPageSessionQueryVariables>;
export const RetrieveSubscriptionPricingDocument = gql`
    query RetrieveSubscriptionPricing($input: RetrieveSubscriptionPricing!) {
  retrieveSubscriptionPricing(input: $input) {
    subscriptionId
    amount
    unitPrice
    quantity
    planId
    planName
    currencyCode
    billingCycles
    trialEnd
    trialStart
    billingPeriod
    billingPeriodUnit
    currentTermStart
    currentTermEnd
    nextBillingAt
    startDate
    coupons {
      Name
      ValidTill
      Status
      DiscountPercentage
      DiscountType
      Period
      PeriodUnit
    }
    purchasedMtus
    inTrial
    addonDetails {
      addonId
      addonName
      addonPriceId
      addonPriceName
      pricingModel
      tiers {
        startingUnit
        endingUnit
        price
      }
      unitPrice
      quantity
      entitlementDetails {
        subscription_id
        feature_id
        feature_name
        feature_type
        value
        name
        is_overridden
        is_enabled
        object
      }
      description
      periodUnit
      isPurchased
    }
    description
  }
}
    `;

/**
 * __useRetrieveSubscriptionPricingQuery__
 *
 * To run a query within a React component, call `useRetrieveSubscriptionPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveSubscriptionPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveSubscriptionPricingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetrieveSubscriptionPricingQuery(baseOptions: Apollo.QueryHookOptions<RetrieveSubscriptionPricingQuery, RetrieveSubscriptionPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveSubscriptionPricingQuery, RetrieveSubscriptionPricingQueryVariables>(RetrieveSubscriptionPricingDocument, options);
      }
export function useRetrieveSubscriptionPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveSubscriptionPricingQuery, RetrieveSubscriptionPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveSubscriptionPricingQuery, RetrieveSubscriptionPricingQueryVariables>(RetrieveSubscriptionPricingDocument, options);
        }
export type RetrieveSubscriptionPricingQueryHookResult = ReturnType<typeof useRetrieveSubscriptionPricingQuery>;
export type RetrieveSubscriptionPricingLazyQueryHookResult = ReturnType<typeof useRetrieveSubscriptionPricingLazyQuery>;
export type RetrieveSubscriptionPricingQueryResult = Apollo.QueryResult<RetrieveSubscriptionPricingQuery, RetrieveSubscriptionPricingQueryVariables>;
export const GetPricingDetailsForProductDocument = gql`
    query GetPricingDetailsForProduct($input: GetPricingDetailsForProductInput!) {
  getPricingDetailsForProduct(input: $input) {
    plans {
      planId
      planName
      planPriceId
      planPriceName
      pricingModel
      unitPrice
      quantity
      trialEnds
      isApplied
      description
      billingPeriod
      trialPeriod
      trialPeriodUnit
      tiers {
        startingUnit
        endingUnit
        price
      }
      entitlementDetails {
        subscription_id
        feature_id
        feature_name
        feature_type
        value
        name
        is_overridden
        is_enabled
        object
      }
      entitledMaus
      entitledEvents
      appliedAddons {
        addonId
        addonName
        addonPriceId
        addonPriceName
        pricingModel
        unitPrice
        quantity
        description
        periodUnit
        isPurchased
        tiers {
          startingUnit
          endingUnit
          price
        }
        entitlementDetails {
          subscription_id
          feature_id
          feature_name
          feature_type
          value
          name
          is_overridden
          is_enabled
          object
        }
      }
      availableAddons {
        addonId
        addonName
        addonPriceId
        addonPriceName
        pricingModel
        unitPrice
        quantity
        description
        periodUnit
        isPurchased
        tiers {
          startingUnit
          endingUnit
          price
        }
        entitlementDetails {
          subscription_id
          feature_id
          feature_name
          feature_type
          value
          name
          is_overridden
          is_enabled
          object
        }
      }
    }
    currencyCode
    billingCycle
  }
}
    `;

/**
 * __useGetPricingDetailsForProductQuery__
 *
 * To run a query within a React component, call `useGetPricingDetailsForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingDetailsForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingDetailsForProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPricingDetailsForProductQuery(baseOptions: Apollo.QueryHookOptions<GetPricingDetailsForProductQuery, GetPricingDetailsForProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingDetailsForProductQuery, GetPricingDetailsForProductQueryVariables>(GetPricingDetailsForProductDocument, options);
      }
export function useGetPricingDetailsForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingDetailsForProductQuery, GetPricingDetailsForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingDetailsForProductQuery, GetPricingDetailsForProductQueryVariables>(GetPricingDetailsForProductDocument, options);
        }
export type GetPricingDetailsForProductQueryHookResult = ReturnType<typeof useGetPricingDetailsForProductQuery>;
export type GetPricingDetailsForProductLazyQueryHookResult = ReturnType<typeof useGetPricingDetailsForProductLazyQuery>;
export type GetPricingDetailsForProductQueryResult = Apollo.QueryResult<GetPricingDetailsForProductQuery, GetPricingDetailsForProductQueryVariables>;
export const GetCheckoutUrlForExistingSubscriptionDocument = gql`
    query GetCheckoutUrlForExistingSubscription($input: GetCheckoutUrlForExistingSubscriptionInput!) {
  getCheckoutUrlForExistingSubscription(input: $input) {
    url
  }
}
    `;

/**
 * __useGetCheckoutUrlForExistingSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetCheckoutUrlForExistingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutUrlForExistingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutUrlForExistingSubscriptionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCheckoutUrlForExistingSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutUrlForExistingSubscriptionQuery, GetCheckoutUrlForExistingSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutUrlForExistingSubscriptionQuery, GetCheckoutUrlForExistingSubscriptionQueryVariables>(GetCheckoutUrlForExistingSubscriptionDocument, options);
      }
export function useGetCheckoutUrlForExistingSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutUrlForExistingSubscriptionQuery, GetCheckoutUrlForExistingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutUrlForExistingSubscriptionQuery, GetCheckoutUrlForExistingSubscriptionQueryVariables>(GetCheckoutUrlForExistingSubscriptionDocument, options);
        }
export type GetCheckoutUrlForExistingSubscriptionQueryHookResult = ReturnType<typeof useGetCheckoutUrlForExistingSubscriptionQuery>;
export type GetCheckoutUrlForExistingSubscriptionLazyQueryHookResult = ReturnType<typeof useGetCheckoutUrlForExistingSubscriptionLazyQuery>;
export type GetCheckoutUrlForExistingSubscriptionQueryResult = Apollo.QueryResult<GetCheckoutUrlForExistingSubscriptionQuery, GetCheckoutUrlForExistingSubscriptionQueryVariables>;
export const GetPlanDetailsForProductDocument = gql`
    query GetPlanDetailsForProduct($input: GetPricingDetailsForProductInput!) {
  getPlanDetailsForProduct(input: $input) {
    planId
    planName
    description
    unitPrice
    quantity
    purchasedMaus
    usedMaus
    purchasedAPICalls
    usedAPICalls
    consumedAPIPercent
    consumedMausPercent
    addonDetails {
      name
      id
      purchased
    }
    trialExpiryInDays
    inTrial
  }
}
    `;

/**
 * __useGetPlanDetailsForProductQuery__
 *
 * To run a query within a React component, call `useGetPlanDetailsForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanDetailsForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanDetailsForProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlanDetailsForProductQuery(baseOptions: Apollo.QueryHookOptions<GetPlanDetailsForProductQuery, GetPlanDetailsForProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanDetailsForProductQuery, GetPlanDetailsForProductQueryVariables>(GetPlanDetailsForProductDocument, options);
      }
export function useGetPlanDetailsForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanDetailsForProductQuery, GetPlanDetailsForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanDetailsForProductQuery, GetPlanDetailsForProductQueryVariables>(GetPlanDetailsForProductDocument, options);
        }
export type GetPlanDetailsForProductQueryHookResult = ReturnType<typeof useGetPlanDetailsForProductQuery>;
export type GetPlanDetailsForProductLazyQueryHookResult = ReturnType<typeof useGetPlanDetailsForProductLazyQuery>;
export type GetPlanDetailsForProductQueryResult = Apollo.QueryResult<GetPlanDetailsForProductQuery, GetPlanDetailsForProductQueryVariables>;
export const UpdatePlanForSubscriptionDocument = gql`
    mutation UpdatePlanForSubscription($input: UpdatePlanForSubscriptionInput!) {
  updatePlanForSubscription(input: $input) {
    isSuccess
    redirectUrl
  }
}
    `;
export type UpdatePlanForSubscriptionMutationFn = Apollo.MutationFunction<UpdatePlanForSubscriptionMutation, UpdatePlanForSubscriptionMutationVariables>;

/**
 * __useUpdatePlanForSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdatePlanForSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanForSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanForSubscriptionMutation, { data, loading, error }] = useUpdatePlanForSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanForSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanForSubscriptionMutation, UpdatePlanForSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanForSubscriptionMutation, UpdatePlanForSubscriptionMutationVariables>(UpdatePlanForSubscriptionDocument, options);
      }
export type UpdatePlanForSubscriptionMutationHookResult = ReturnType<typeof useUpdatePlanForSubscriptionMutation>;
export type UpdatePlanForSubscriptionMutationResult = Apollo.MutationResult<UpdatePlanForSubscriptionMutation>;
export type UpdatePlanForSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdatePlanForSubscriptionMutation, UpdatePlanForSubscriptionMutationVariables>;